// extracted by mini-css-extract-plugin
export default {"table":"styles_table__PrDI3","actions":"styles_actions__0UM29"};